import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { Button } from "@/shared/ui/Button";
import type { VoteWindow } from "../../VoteWindow";
import styles from "./StartVoteButton.module.css";

function useIsStartVoteButtonDisabled(voteWindow: VoteWindow) {
    return useSyncExternalStore(
        voteWindow.subscribeStartVoteButtonDisabled,
        voteWindow.getStartVoteButtonDisabled,
    );
}

export function StartVoteButton({ onStart }) {
    const { t } = useTranslation();
    const isStartVoteButtonDisabled = useIsStartVoteButtonDisabled(canv.appInterface.voteWindow);

    const isButtonDisabled = isStartVoteButtonDisabled || canv.isGuest();

    return (
        <Button disabled={isButtonDisabled} className={styles.button} onClick={onStart}>
            {t("vote.startVoting")}
        </Button>
    );
}
